export const SignalSourceIcon = ({source}: {source: string}) => {
  switch (source) {
    case 'Schaeffler':
      return <SchaefflerIcon />
    case 'PxTrend':
      return <PxTrendIcon />
    case 'Dalog':
      return <DalogIcon />
    case 'MachineSentry':
      return <MachineSentryIcon />
    default:
      return null
  }
}

const SchaefflerIcon = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <rect width={16} height={16} rx={2} fill="url(#pattern0_212_2866)" />
    <defs>
      <pattern id="pattern0_212_2866" patternContentUnits="objectBoundingBox" width={1} height={1}>
        <use xlinkHref="#image0_212_2866" transform="scale(0.0625)" />
      </pattern>
      <image
        id="image0_212_2866"
        width={16}
        height={16}
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAEKADAAQAAAABAAAAEAAAAAA0VXHyAAACOElEQVQ4EaVTS2sTURT+5pE2GWPaxBrSVmlrSTW2RhHNQsX4CEqLD3Ahin+hC8V1ogRx4U5dVNzpQnQhboqgdSFF67MtKsaAdMjDUktePmptksmM516Y2DEb0TMw93W+75x7zncFf2y/rhuGgH8wURAMuWboDeCOFi9C3Zuxxu3DdDaBVOETujydKP74ArWQRUWr8nA1CiwLEGDQZ5rf2434odPY1rUJFIGDZvJZbF27EY+SEzg3ehm5hSJ3Z1jRBLJxoKMPV45HKXoQS9UyXqXfQSCS7UQmiRKUJgdE0QKBvJzgaDCCPm8P3zp79yIefngCn2s1Rk7GEexcz8lY1OVmoVvlbK2frWhW+PzztxwujV3n2bydTWJJK9d92EToje4zzBqcCh1BbHAYsiSDOgMGeKZO46k6ianMe5S1ihVM2UiecM95c3cml4aNwKyA7O4sfXb/Y1sOIrJhB9LFWWRKc6Y7wf8gqNY0ijaFl6k3lIEOh80Ol30l70ab043d/hBSRKLmM5ykgaC/3Y9IYCdv3Y3n93D79SgeJMahNDsQ8PVSF+zQdI0XlzE0tPFAYBcuHD6DkRNxtJOYWEbJeRXXxm/VxdPm9NSvwCaWLrC0mbUqLsSGhsEUycQ0NLAHTbKNnyXmPvLR/Fl0wMRiGssmTHderPyEW2nh2y+oNncm75sufLQQqCTZCSpifqGE0uJXDPaH4SEwW4+RqK4+von57wULgbAuuvf3Q7Ac/d1ClgTR+J/n/AsLHslzv5d4zAAAAABJRU5ErkJggg=="
      />
    </defs>
  </svg>
)

const PxTrendIcon = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <rect width={16} height={16} fill="url(#pattern0_212_2872)" />
    <defs>
      <pattern id="pattern0_212_2872" patternContentUnits="objectBoundingBox" width={1} height={1}>
        <use xlinkHref="#image0_212_2872" transform="scale(0.03125)" />
      </pattern>
      <image
        id="image0_212_2872"
        width={32}
        height={32}
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
)

const MachineSentryIcon = (props) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <rect width={18} height={18} fill="url(#pattern0_212_2868)" />
    <defs>
      <pattern id="pattern0_212_2868" patternContentUnits="objectBoundingBox" width={1} height={1}>
        <use xlinkHref="#image0_212_2868" transform="scale(0.03125)" />
      </pattern>
      <image
        id="image0_212_2868"
        width={32}
        height={32}
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAIKADAAQAAAABAAAAIAAAAACshmLzAAADn0lEQVRYCe1Uz2sdVRT+7rl3Zl4meU3y2qepECxaQZouNGkURFzUmKig4KJuXLqqti78A2yCuBAFFy5ciggir0IXKtSCGkihoFRFTIxt0Wha+4NEk/S9l/lx7z2emfh89S/QxTtw5s7cH+d857vfGaBnPQZ6DPQY6DHwHzOg/snPUKg+VIfGfQjcOobWf+CLF7M5NadO4AQrKMYdEzGsuh9OVQZt8s3G5vcbZYDRh/diQ01A+90o9oFkuhjlmHYxoAkUMvK2QZ79iMnqF5ift0XuLoD+sRG4yuuI4sNQdguu+QYev/f9Bo5gqbHEJw+eNIur0QvQ4TFJEFCen6rWornta+3RzOBVhPGD0LoCSSu2k7x4k9RQqnDA2kgAvIfd8TGszCfFsikepYUD41DBtJzNZXoP3OCL+PzaV0deenYZmMVrN+oHQOnz4HAA2niv6alWbk7binlM6nhE0iyRTxehtPJEnajlSMKuYvLMasAr/x36676zoQtARQMSRIP9FcFgEAV3y/vhOcwuf3zod83Wz4BoRMq4DOsSGD1KioeJdN2ThGG7InWeFva1BN/hoczCUnsKw2GSkrouAJd5sZHLlZarXQDFMc8BrL8Ao34F81EpZebNd840XL4VOR6cEWbI6PyMZ9zp4e/KnGkhSc8iwBQC/ahjPQUncboXWyZxqq+cRpatgezb9+x/8l1cElRiXQDFQbkpcYp08GWau2eYMN50dhK8qyr3exDsblQUPk2IjnsRmBahuWr6AbYNiTifgHKxYsWFnksS/gYicmSxEFrtVz48/tsfWwuyYVH8FgBSPoRDiRnGxi/nmVnwhOdAlaeF8lhCxIT8VKViLrVaZW4Rd6qG9tbNxqr9VsT5s1bboVGW04LNjklhodMu9bgNjl4WGCOZ41pn+d8MCFQRC/WTa9707iNv9TSUEZdSfH6d2DfWVnETQ1baS8D60DV/aR6C47cQ6cipgJ3cB8oG66TADteyIvqoqdReYNJXOqtduRaos7TN1uabm7E6sK96lpLkQ9i0TyIOkKVPbP/IueHhRLTHHlneRpp5E3iniHLIDDjIwVrc3OLFt7LSYbInWYgoeWV2c2qlA6Arl9rkKJo8Li22tu/2yvmVok+rE3ukmmlYCuPAf9Zun786hrHwp776A1bltThOvq5402oiHs0yabYwLKroxN4Zy08v2nIZduXruHzuT5GEqKT4UfWsx0CPgR4DPQb+Bwz8BWbGj7Xslk7iAAAAAElFTkSuQmCC"
      />
    </defs>
  </svg>
)

const DalogIcon = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <rect width={16} height={16} fill="url(#pattern0_212_2870)" />
    <defs>
      <pattern id="pattern0_212_2870" patternContentUnits="objectBoundingBox" width={1} height={1}>
        <use xlinkHref="#image0_212_2870" transform="scale(0.0625)" />
      </pattern>
      <image
        id="image0_212_2870"
        width={16}
        height={16}
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAEKADAAQAAAABAAAAEAAAAAA0VXHyAAACQ0lEQVQ4EcVSTWhTQRCeffv+krw0P2iIKRgVbbEeevEgCtKbJwWl9eDNiyCUoHgSPHpRxEIOHgoiCAWligcF8VAQBdEWCqYmVbDRVloxTay2RPrevt11Z2OaHurJgwM7szM7P9/MLMD/JoIALt58FXk5vTC0VFvLGYQIMEDbhRCQikdg/670j0SXPfl6ZqVcHj8dbAZtotKdtWNR1zjvOvSQYRCQaERGKPgshJm5OgMpv9omfXj26rORO1eOfUEXJAOZy7i0TEOY1AA8ljqORX3bNJiGAtJSmHb+CsILbyv1kcvFF9sxDkknwIuuipcWyd3dibHePZlzO7LJUUlIA82qCFltBsffvKsN/vHrJGgbUEog0vO86qPl+40njXtTB7LOAzWOsOVD7HXGB2+NlVKobyBoPbZ4CCTsl4sDa9XPt/nCfLFgzCYEAY1CdQcKRc+n+sq2vyaQUpKAiVASyYjrBC7hi5RA2G6Tc2H+bAqKCfQWWnU73ARpTvnp512nTtwA04qOLvfk6VItrRKDUFlc2/qWjFurGLFlC2qTEIvS3mH/oDNQyu2bnG0UhJARDFBSbQkmrg0fqaG+JQJlJ+W5xhlS/T7EQu4o3SJE9RAKoNR4n0m5d5Wuh6oRrFuUSC4MrrJjBZQsFE4QcA8Loq76ZvGYXcplYpceF0+WsDqSRsBjnp/03KdNn39Qq27PSjuoWLV/yoQU04f7sxPXC0c/quobPvqj4dTHKxXLm7dbH0+Hdlg+v1f29QHbHNh5/cfbb9Kv5pWVde4rAAAAAElFTkSuQmCC"
      />
    </defs>
  </svg>
)
